import { SxProps, Theme, useTheme } from '@mui/material'

export const getStyles = (
  getStyles: (theme: Theme, other?: any) => void = () => {},
  other: any = {},
): Record<string, SxProps<Theme>> => {
  const theme = useTheme()
  const result = getStyles(theme, other) as unknown as Record<
    string,
    SxProps<Theme>
  >
  return result // предполагается, что `result` уже соответствует `Record<string, SxProps<Theme>>`
}

export const checkMobileDevice = () => {
  const regExp = new RegExp(
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
  )
  return regExp.test(navigator.userAgent)
}
